import { render, staticRenderFns } from "./ExpressOrderShowUser.vue?vue&type=template&id=3eda4e4d&scoped=true"
import script from "./ExpressOrderShowUser.vue?vue&type=script&lang=js"
export * from "./ExpressOrderShowUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eda4e4d",
  null
  
)

export default component.exports